import { LenssourceModelLensSourceType as LensSourceType } from "../../../gql-generated/types";

const labelsMap = new Map<LensSourceType, string>([
    [LensSourceType.BusinessProfile, "Business Profile"],
    [LensSourceType.SnapchatUserUnset, "User Profile"],
    [LensSourceType.ScheduleV3, "Snapchat Pack"],
    [LensSourceType.LensSpace, "Lens Folder"],
]);

export function getLensSourceTypeLabel(lensSourceType: LensSourceType): string {
    return labelsMap.has(lensSourceType) ? (labelsMap.get(lensSourceType) as string) : lensSourceType;
}
